import { ITopArtist } from '#/types/API/topArtists';
import { ITopTrack } from '#/types/API/topTracks';
import withMatcher from '#/utils/withMatcher';
import { ITopTrackWithFavorite } from '../reducers/userProfile';

export const createActionUserProfileAddTopArtists = withMatcher(
  (payload: ITopArtist[]) => {
    return {
      type: 'user_profile/add_top_artists',
      payload,
    };
  }
);

export const createActionUserProfileLoadingTopArtists = withMatcher(() => {
  return {
    type: 'user_profile/loading_top_artists',
  };
});

export const createActionUserProfileErrorTopArtists = withMatcher(() => {
  return {
    type: 'user_profile/error_top_artists',
  };
});

export const createActionUserProfileAddTopTracks = withMatcher(
  (payload: ITopTrackWithFavorite[]) => {
    return {
      type: 'user_profile/add_top_tracks',
      payload,
    };
  }
);

export const createActionUserProfileSetTopTrackIsFavorite = withMatcher(
  (payload: { track: ITopTrack['id']; favorite: boolean }) => {
    return {
      type: 'user_profile/set_top_track_is_favorite',
      payload,
    };
  }
);

export const createActionUserProfileLoadingTopTracks = withMatcher(() => {
  return {
    type: 'user_profile/loading_top_tracks',
  };
});

export const createActionUserProfileErrorTopTracks = withMatcher(() => {
  return {
    type: 'user_profile/error_top_tracks',
  };
});
